<template>
  <BModal
    ref="modalSingleTask"
    size="xl"
    scrollable
    centered
    hide-header
    no-close-on-esc
    no-enforce-focus
    no-close-on-backdrop
    modal-class="full-screen modal-no-padding"
    aria-hidden="false"
    role="dialog"
  >
    <div
      class="h-100"
      style="overflow-y: scroll; overflow-x: hidden;"
    >
      <ValidationObserver
        ref="formImportTask"
      >
        <form
          role="form"
          novalidate
          @submit.prevent
        >
          <BRow>

            <BCol
              cols="12"
              md="6"
            >
              <ValidationProvider
                v-slot="{ errors }"
                vid="officer"
                name="officer"
                rules="required"
              >
                <BFormGroup
                  label="Officer"
                  label-for="fOfficer"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <VSelect
                    v-model="selected.fsOfficer"
                    input-id="fOfficer"
                    label="officer_name"
                    clearable
                    append-to-body
                    placeholder="select officer here"
                    :options="options.fsOfficers"
                    :disabled="[
                      state.busy,
                      fetching.fsOfficers
                    ].some(isTrue => isTrue)"
                    :loading="fetching.fsOfficers"
                    :calculate-position="calculateDropPosition"
                    :class="{ 'is-invalid': errors.length > 0 }"
                    @search="searchFSOfficers"
                  >
                    <template #option="{ officer_name, sso_id }">
                      <div
                        class="text-break text-wrap"
                      >
                        <strong class="text-primary">{{ sso_id }}</strong> - {{ officer_name }}
                      </div>
                    </template>
                    <template #selected-option="{ officer_name, sso_id }">
                      <div
                        class="text-break text-wrap"
                      >
                        <strong class="text-primary">{{ sso_id }}</strong> - {{ officer_name }}
                      </div>
                    </template>
                    <template #no-options="">
                      no available officer
                    </template>
                  </VSelect>
                  <div
                    v-if="(errors.length > 0)"
                    class="invalid-feedback"
                    v-text="errors[0]"
                  />
                </BFormGroup>
              </ValidationProvider>
            </BCol>
            <BCol
              cols="12"
              md="6"
            >
              <ValidationProvider
                v-slot="{ errors }"
                vid="attachments"
                name="attachments"
                rules="required"
              >
                <BFormGroup
                  label="Attachments"
                  label-for="fAttachments"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <BFormFile
                    id="fAttachments"
                    v-model="formFile.attachments"
                    accept=".xls,.xlsx"
                    :state="errors.length > 0 ? false : null"
                    :disabled="state.busy || officer.sso_id === ''"
                    @change="validateExcelFile"
                  />
                  <div
                    v-if="errors.length > 0"
                    class="invalid-feedback"
                    v-text="errors[0]"
                  />
                </BFormGroup>
              </ValidationProvider>
            </BCol>
            <BCol
              cols="12"
              md="6"
            >
              <ValidationProvider
                v-slot="{ errors }"
                vid="schedule"
                name="schedule"
                rules="required"
              >
                <BFormGroup
                  label="Activity Month"
                  label-for="fActivityMonth"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <BFormInput
                    id="fActivityMonth"
                    v-model="formImportTask.schedule"
                    type="month"
                    :state="errors.length > 0 ? false : null"
                    :disabled="state.busy"
                    readonly
                  />
                  <div
                    v-if="(errors.length > 0)"
                    class="invalid-feedback"
                    v-text="errors[0]"
                  />
                </BFormGroup>
              </ValidationProvider>
            </BCol>
            <BCol
              cols="12"
              md="6"
            >
              <ValidationProvider
                v-slot="{ errors }"
                vid="sso_id"
                name="employee id"
                :rules="`required|is:${officer?.sso_id || ''}`"
              >
                <BFormGroup
                  label="Employee ID"
                  label-for="fEmployeeId"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <BFormInput
                    id="fEmployeeId"
                    v-model="formImportTask.sso_id"
                    type="text"
                    placeholder="no employee id"
                    :state="errors.length > 0 ? false : null"
                    :disabled="state.busy"
                    readonly
                  />
                  <div
                    v-if="(errors.length > 0)"
                    class="invalid-feedback"
                    v-text="errors[0]"
                  />
                </BFormGroup>
              </ValidationProvider>
            </BCol>
          </BRow>
        </form>
      </ValidationObserver>
      <BTable
        small
        hover
        bordered
        responsive
        show-empty
        class="min-h-275px"
        :stacked="tableImportedTasks.stacked"
        :items="tableImportedTasks.rows"
        :fields="tableImportedTasks.fields"
      >
        <template #cell(index)="{ index }">
          {{ Number(index) + 1 }}
        </template>
      </BTable>
    </div>
    <template #modal-footer="{ cancel }">
      <BButton
        variant="primary"
        :disabled="state.busy"
        @click.prevent="validateImportTask"
      >
        Import Officer Tasks
      </BButton>
      <BButton

        variant="outline-dark"
        :disabled="state.busy"
        @click.prevent="discardBtnEvent => preventAriaHidden(discardBtnEvent, cancel)"
      >
        Discard
      </BButton>
    </template>
  </BModal>
</template>
<script>
import { mapGetters } from 'vuex'
import { utils, writeFile } from 'data-validation-xlsx'
import MOMENT from 'moment'
import QUERY from 'lodash'

import MxMisc from '@/mixins/misc'
import MxFormatter from '@/mixins/formatter'
import MFSOfficers from '@/mixins/accounts/fsos'
import MActivities from '@/mixins/maintenances/activities'

import { SASMFsoTask } from '@/services/asm'

export default {
  name: 'ASMTasksSingleUploader',

  mixins: [
    MxMisc,
    MxFormatter,
    MActivities,
    MFSOfficers
  ],

  emits: [
    'imported'
  ],

  data () {
    return {
      state: {
        busy: false,
        downloading: false
      },
      selected: {
        team: {
          id: ''
        },
        activityType: 'Event'
      },
      officer: {
        sso_id: '',
        first_name: '',
        last_name: ''
      },
      formFile: {
        attachments: null
      },
      formImportTask: {
        assignee_id: '',
        sso_id: '',
        schedule: '',
        file_name: '',
        tasks: []
      },
      tableImportedTasks: {
        stacked: 'sm',
        fields: [
          { key: 'index', label: '#' },
          { key: 'officer_id' },
          { key: 'officer_name', label: 'Officer Name', class: 'min-w-275px' },
          { key: 'activity_name', class: 'min-w-325px' },
          { key: 'event_plan', label: 'Number of Events', class: 'text-right' },
          {
            key: 'error',
            label: 'Line Error',
            class: 'text-danger',
            formatter: row => row?.error ? `${String(row?.column || '').toLowerCase()} ${row?.error || ''}` : ''
          }
        ],
        rows: [],
        errors: []
      }
    }
  },

  computed: {
    ...mapGetters({
      currentUser: 'auth/user'
    })
  },

  watch: {
    'selected.fsOfficer' (officer) {
      this.officer.sso_id = officer?.sso_id || ''
      this.officer.first_name = officer?.first_name || ''
      this.officer.last_name = officer?.last_name || ''
      this.formImportTask.assignee_id = officer?.id || ''

      if (!officer) {
        this.formImportTask.sso_id = ''
        this.formImportTask.schedule = ''
        this.formFile.attachments = null
        this.tableImportedTasks.rows = []
        this.tableImportedTasks.errors = []
      }
    },

    'formFile.attachments' (attachments) {
      if (!attachments) {
        this.formImportTask.sso_id = ''
        this.formImportTask.schedule = ''
      }
    }
  },

  mounted () {
    if (this.currentUser) {
      this.selected.team.id = this.currentUser?.team || ''
    }
  },

  methods: {

    async downloadTemplate (officer, selectedMonth) {
      this.state.downloading = true

      return new Promise(resolve => {
        this.getActivities(this).finally(() => {
          const month = MOMENT(selectedMonth).format('YYYY-MM')
          const shortFirstName = String(officer?.first_name || '').split(' ')
          const first = shortFirstName.length >= 1 ? String(shortFirstName[0]).substring(0, 1) : ''
          const second = shortFirstName.length > 1 ? String(shortFirstName[1]).substring(0, 1) : ''
          const shortName = String(`${first}${second}.${officer?.last_name}`).toUpperCase()

          const sheetProtection = {
            password: this.generateId(8), // optional
            selectLockedCells: true,
            selectUnlockedCells: true,
            formatCells: false,
            formatColumns: false,
            formatRows: false,
            insertColumns: false,
            insertRows: false,
            insertHyperlinks: false,
            deleteColumns: false,
            deleteRows: false,
            sort: false,
            autoFilter: false,
            pivotTables: false,
            objects: false,
            scenarios: false
          }

          const book = utils.book_new()

          const activitySheetData = [
            [
              'Activity Name'
            ],
            ...this.options.activities.map(
              activity => [
                activity.activity_name
              ]
            )
          ]

          const activitySheet = utils.aoa_to_sheet(activitySheetData)

          const activityLength = this.options.activities.length

          activitySheet['!cols'] = [
            { wch: 50 } // Activity Name
          ]

          activitySheet['!protect'] = sheetProtection

          const officerTaskData = [
            [
              'Officer ID', // A
              'Officer Name', // B
              'Activity Name', // C
              'Number of Events' // E
            ],
            ...Array.from({ length: this.options.activities.length }).map(
              () => ([
                officer.sso_id,
                `${officer.first_name} ${officer.last_name}`,
                '',
                0 // Number of Events
              ])
            )
          ]

          const officerTask = utils.aoa_to_sheet(officerTaskData)

          officerTask['!cols'] = [
            { wch: 15 }, // Officer ID
            { wch: 40 }, // Officer Name
            { wch: 50 }, // Activity Name
            { wch: 20 } // Number of Events
          ]

          officerTask['!dataValidation'] = [
            {
              type: 'list-in-sheet',
              values: `=Activities!A$2:A$${activityLength + 1}`,
              sqref: 'C2:C99'
            }
          ]

          const sheetName = `${officer.sso_id}-${shortName}`
          utils.book_append_sheet(book, officerTask, sheetName)
          utils.book_append_sheet(book, activitySheet, 'Activities')

          const excelName = `${month}-${officer.sso_id}.xlsx`
          writeFile(book, excelName, { bookType: 'xlsx', type: 'binary' })

          this.state.downloading = false
          resolve(excelName)
        })
      })
    },

    importTasks () {
      this.tableImportedTasks.rows = []
      this.tableImportedTasks.errors = []

      this.formImportTask = Object.assign(this.formImportTask, {
        assignee_id: this.officer?.id || '',
        sso_id: '',
        schedule: '',
        file_name: '',
        tasks: []
      })

      this.getFSOfficers(this, '', this.currentUser.team, this.currentUser.area)
      this.getActivities(this)

      this.$refs.modalSingleTask.show()
    },

    async validateFormFile (file) {
      return new Promise((resolve, reject) => {
        const extractPayloads = String(file.name).replace('.xlsx', '').replace('.xls', '').split('-')

        const validations = {
          swal: '<h6>File name should be in the format: <br /><b>YYYY-MM-EmployeeID</b> <br /><br />Example: 2025-01-10001.xlsx</h6>',
          input: 'File name should be in the format: YYYY-MM-EmployeeID. Example: 2025-01-10001.xlsx'
        }

        if (extractPayloads.length <= 2) {
          return reject(validations)
        }

        const year = extractPayloads[0]
        const month = extractPayloads[1]
        const employeeID = String(extractPayloads[2])

        const dateFormat = 'YYYY-MM'
        const originalDate = `${year}-${month}`

        const formattedDate = MOMENT(originalDate, dateFormat, true)

        if (!formattedDate.isValid() && employeeID) {
          return reject(validations)
        }

        resolve({
          schedule: formattedDate.format(dateFormat),
          employeeID,
          fileName: file.name
        })
      })
    },

    async validateExcelFile ({ target }) {
      this.formImportTask.tasks = []
      this.tableImportedTasks.rows = []
      this.tableImportedTasks.errors = []

      const file = QUERY.first(target.files)

      if (file) {
        this.validateFormFile(file).then(
          ({ employeeID, schedule, fileName }) => {
            this.validateImportedTask(file, this.options.activities).then(
              ({ rows, errors }) => {
                this.tableImportedTasks.errors = errors
                this.tableImportedTasks.rows = rows

                this.formImportTask = Object.assign(this.formImportTask, {
                  schedule,
                  sso_id: employeeID,
                  file_name: fileName,
                  tasks: rows.map(
                    row => Object.assign(row, {
                      schedule
                    })
                  )
                })
              }
            )
          }
        ).catch(
          ({ swal, input }) => {
            this.swalInvalid(swal, 'Invalid File Name Format').then(() => {
              this.$refs.formImportTask.setErrors({
                attachments: [input]
              })
            })
          }
        )
      }
    },

    validateImportTask () {
      this.$refs.formImportTask.validate().then(
        validTask => {
          if (!validTask) {
            return this.swalInvalid()
          }

          const file = this.formFile.attachments
          if (file) {
            this.validateFormFile(file).then(() => {
              const invalidExcel = this.tableImportedTasks.errors.length > 0
              const invalidCards = this.formImportTask.tasks.length <= 0

              const currentMonth = MOMENT()
              const currentSchedule = MOMENT(this.formImportTask.schedule).isSameOrAfter(currentMonth, 'month')

              if (invalidExcel || invalidCards || !currentSchedule) {
                if (!currentSchedule) {
                  this.$refs.formImportTask.setErrors({
                    schedule: [
                      `The activity month must be greater than or equal to ${currentMonth.format('MMMM YYYY')}`
                    ]
                  })
                }

                return this.swalInvalid()
              }

              this.swalConfirm({
                html: 'Import Officer Tasks?',
                confirmButtonText: 'Import',
                customClass: {
                  confirmButton: 'btn btn-sm btn-secondary'
                },
                preConfirm: () => {
                  return this.putImportTask().catch(
                    ({ message }) => {
                      if (message && message.errors) {
                        this.$refs.formImportTask.setErrors({
                          attachments: [message?.message]
                        })

                        this.$refs.formImportTask.setErrors(message.errors)
                      }
                    }
                  )
                }
              })
            }).catch(
              ({ swal, input }) => {
                this.swalInvalid(swal, 'Invalid File Name Format').then(
                  () => {
                    this.$refs.formImportTask.setErrors({
                      attachments: [input]
                    })
                  }
                )
              }
            )
          }
        }
      )
    },

    async putImportTask () {
      return SASMFsoTask.singleImport(this.formImportTask).then(
        ({ data }) => {
          this.swalSuccess(data.message).then(() => {
            this.$refs.modalSingleTask.hide()

            this.$emit('imported')
          })
          return data
        }
      )
    }
  }
}
</script>
